import { toNumber } from '../../helper/number';
import { ERROR_VALUE } from '../../error';

export const SYMBOL = '^';

export default function func(exp1: string | number, exp2: string | number) {
    const result = Math.pow(toNumber(exp1), toNumber(exp2));

    if (isNaN(result)) {
        throw Error(ERROR_VALUE);
    }

    return result;
}

func.SYMBOL = SYMBOL;
